module.exports = __webpack_public_path__ + "static/media/File.6a037b68.png";